import { Spin } from "antd";
import "./user-avatar.css";
import UserAvatar from "./user-avatar";

function UserAvatarWithDetails({
  fullName,
  email,
  // workEmail,
  // style,
  photo,
  badge,
  // showAvatar,
  subscription,
  // Forwarded to the inner avatar so UI automation can target it; falls back
  // to UserAvatar's own default when omitted.
  dataTestId
}: any) {
  const url = photo || null;
  // const size1 = size || "default";
  // const showAvatar1 = showAvatar !== undefined ? showAvatar : true;

  return (
    <div className="flex items-center justify-center gap-2">
      <UserAvatar
        url={url}
        isRect={false}
        fullName={fullName}
        dataTestId={dataTestId}
      />
      <div className="flex-col">
        <div className="name">
          {fullName || <Spin size="small" />} {badge}
        </div>
        <div className="email">{email}</div>
        {subscription && (
          <div className="text-ciq-gray-950 text-opacity-80 text-[10px] font-normal">
            Subscription: <span className=" font-semibold">{subscription}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserAvatarWithDetails;
